export const VIEWPORT_MOBILE_SMALL = {
  width: 320,
  height: 640
}

export const VIEWPORT_DEFAULT_MOBILE = {
  width: 420,
  height: 640
}

export const VIEWPORT_DEFAULT_DESKTOP = {
  width: 1280,
  height: 768
}

export const VIEWPORT_DEFAULT_TABLET = {
  width: 900,
  height: 640
}

export const VIEWPORT_DEFAULT_LARGE_DESKTOP = {
  width: 1440,
  height: 768
}

export const VIEWPORT_DEFAULT_VERY_LARGE_DESKTOP = {
  width: 1920,
  height: 768
}

export const VIEWPORT_DOMAIN = 'viewport'

export const VIEWPORT_STATE = {
  ...VIEWPORT_DEFAULT_MOBILE
}

export const VIEWPORT_ACTION = {
  UPDATE: 'VIEWPORT_UPDATE'
}
